import md5 from 'md5'

import request from '@/utils/request'
import { restData } from '@/config'

// token登录
export function appTokenLogin (params) {
  return request.get(restData.checkUserInfoUrl, params)
}

// session登录
export function appSessionLogin () {
  return request.get(restData.checkUserInfoUrl)
}

// 用于页面登录
export function pageLogin (params) {
  const {
    username,
    password,
  } = params

  return request.post(restData.checkLoginUrl, {
    username,
    password,
    // password: params.md5 ? password : md5(password),
  })
}

// 用于页面注销
export function pageLogout () {
  return request.get(restData.logoutUrl)
}

export function getServiceAreaData (params) {
  return request.post('地址', params)
}
// 服务于修改密码操作
export function changePassword (params) {
  return request.post('/rest/updatePassword', params)
}
